import classNames from "classnames";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CardWrapper,
  ModalFaildReques,
  FileToBig,
  ModalStorage,
  NotFound,
  GeneratorPageTemplates
} from "../../components";
import { isNoEditRoute } from "../../hooks/helpers";
import useTypeDecription from "../../hooks/useTypeDecription";
import { getAllCategories } from "../../redux/requests";
import useIsNoIframe from "../../hooks/useIsNoIframe";
import NavigateCards from "../../components/navigation/NavigateCards";
import { webView } from "../../variables/webView";

const ERROR_MESSAGES = {
  login: "upload only user login",
};

export default function SecondScreen({ children }) {
  const { errorFile, type, isErrorPage, error, isStorageModal } = useSelector(
    (state) => ({
      errorFile: state.getQrLinkSlice.errorFile,
      type: state.typeCard.type,
      isErrorPage: state.navigation.isErrorPage,
      error: state.getQrLinkSlice.error,
      isStorageModal: state.modals.isStorageModal,
    })
  );

  const dispatch = useDispatch();
  const { isNoIframe, isNoEditRoute } = useIsNoIframe();

  const { pasteBottomDescription, showFooter, hideFooter, pasteTemplates } =
    useTypeDecription();

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getAllCategories());
    pasteTemplates();
    pasteBottomDescription();

    const modalApps = document.querySelector(".modal-apps");
    if (modalApps) {
      modalApps?.classList.add("d-none");
    }
    if (document.querySelector("#description")) {
      showFooter();
    }
    !isNoIframe && document.querySelector(".modal-cookies")?.remove();
    return () => hideFooter();
  }, []);

  useEffect(() => {
    const scriptType = "application/ld+json";
    let script = document.body.querySelector(`script[type="${scriptType}"]`);
    const ratingData = document.querySelector("#rating-data")?.dataset.rating;
    if (!script && ratingData) {
      const rating = JSON.parse(ratingData);
      if (rating.totalVotes >= 1) {
        script = document.createElement("script");
        script.type = scriptType;
        script.innerHTML = JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebApplication",
          name: rating.name,
          url: window.location.href,
          applicationCategory: "QR Code Generator",
          aggregateRating: {
            "@type": "AggregateRating",
            bestRating: "5",
            ratingValue: String(rating.averageRating),
            ratingCount: String(rating.totalVotes),
          },
        });
        document.body.prepend(script);
      }
    }

    return () => {
      const existingScript = document.body.querySelector(
        `script[type="${scriptType}"]`
      );
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  const outsideWrapper = ["link-list", "vcard"];
  const isWrapped = !outsideWrapper.includes(type);

  const templateGeneratorPageBlock = document.getElementById(
    "templateGeneratorPageBlock"
  );

  useEffect(() => {
    const chooseTemplateBtn = document.querySelector("#chooseTemplateBtn");
    const handleClick = () => {
      gtag("event", `generator_select_template_${type}`);
    };
    chooseTemplateBtn?.addEventListener("click", handleClick);
    return () => {
      chooseTemplateBtn?.removeEventListener("click", handleClick);
    };
  }, [type]);

  useEffect(() => {
    if (error?.message === ERROR_MESSAGES.login) {
      window.location.href = `/login?targetBack=${window.location.pathname}`;
    }
  }, [error]);

  if (isErrorPage) {
    return <NotFound />;
  }

  const isShowBottomDescription =
    !templateGeneratorPageBlock && isNoIframe && isNoEditRoute && !webView;

  return (
    <div>
      {errorFile && <FileToBig />}
      {error && !error[0]?.field && <ModalFaildReques />}
      {isStorageModal && <ModalStorage />}
      <div
        className={classNames("container", {
          "mt-5": !isNoEditRoute,
        })}
      >
        <NavigateCards />
        <CardWrapper isWrapped={isWrapped}>
          <div
            className="pt-0"
            style={isWrapped ? { backgroundColor: "white" } : {}}
          >
            {children}
          </div>
        </CardWrapper>
        {isShowBottomDescription && (
          <div className="pt-5">
            <GeneratorPageTemplates type={type} />
          </div>
        )}
      </div>
    </div>
  );
};